import {
  ChatCircle,
  ChalkboardTeacher,
  Megaphone,
  UsersThree,
} from "@phosphor-icons/react";

// Map a conversation.type to an icon + tint + label prefix used across the UI.
export const CONVERSATION_META = {
  direct: {
    icon: ChatCircle,
    label: "Direct",
    bg: "bg-neutral-100",
    color: "text-neutral-700",
  },
  family: {
    icon: UsersThree,
    label: "Family",
    bg: "bg-primary/10",
    color: "text-primary-hover",
  },
  classroom: {
    icon: ChalkboardTeacher,
    label: "Classroom",
    bg: "bg-secondary/30",
    color: "text-neutral-900",
  },
  announcement: {
    icon: Megaphone,
    label: "Announcement",
    bg: "bg-[#C6851E]/10",
    color: "text-[#C6851E]",
  },
};

export function iconForType(type) {
  return CONVERSATION_META[type]?.icon || ChatCircle;
}

export function metaForType(type) {
  return CONVERSATION_META[type] || CONVERSATION_META.direct;
}

// Short relative time like "2h", "yesterday", "Mar 4".
export function shortTime(iso) {
  if (!iso) return "";
  const d = typeof iso === "string" ? new Date(iso) : iso;
  const diffMs = Date.now() - d.getTime();
  const mins = Math.round(diffMs / 60000);
  if (mins < 1) return "now";
  if (mins < 60) return `${mins}m`;
  const hours = Math.round(mins / 60);
  if (hours < 24) return `${hours}h`;
  const days = Math.round(hours / 24);
  if (days === 1) return "yesterday";
  if (days < 7) return `${days}d`;
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

export function conversationTitle(conv, helpers = {}) {
  if (conv.subject) return conv.subject;
  switch (conv.type) {
    case "family":
      return helpers.familyName?.(conv.family_id) || "Family thread";
    case "classroom":
      return helpers.classroomName?.(conv.classroom_id) || "Classroom";
    case "announcement":
      return conv.classroom_id
        ? helpers.classroomName?.(conv.classroom_id) || "Classroom announcement"
        : "School announcement";
    default:
      return "Conversation";
  }
}
